import Axios, { AxiosError, AxiosResponse } from 'axios';
import { toast } from '@sparrowengg/twigs-react';
declare module 'axios' {
  export interface AxiosRequestConfig {
    handlerEnabled?: boolean;
  }
}
const API_URL = `${process.env.REACT_APP_SPARROW_APPS_URL}/v2/api/`;
const axios = Axios.create({
  baseURL: API_URL,
  handlerEnabled: true
});

const V3_API_URL = `${process.env.REACT_APP_SPARROW_APPS_URL}/v2/core-api`;
const axiosV3 = Axios.create({
  baseURL: V3_API_URL,
  handlerEnabled: true
});

const errorHandler = (error: AxiosError) => {
  if (error.response?.status === 401) {
    // Show error toast but don't redirect
    toast({
      variant: 'error',
      description: 'Authentication failed. Please check your token.'
    });
  }
  return Promise.reject(error);
};

const successHandler = (response: AxiosResponse): any => {
  return response;
};

axios.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

axiosV3.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export default axios;
export { axiosV3 };
